import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { motion } from 'framer-motion';
import '../styles/LegalPages.scss';

const Privacy = () => {
    return (
        <div className="legal-page privacy-page">
            <motion.div
                className="page-header"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
            >
                <div className="header-background" />
                <Container>
                    <motion.div
                        initial={{ y: -30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="header-content"
                    >
                        <Typography variant="h1">Adatkezelési Tájékoztató</Typography>
                        <Typography variant="subtitle1">
                            Ismerje meg adatkezelési gyakorlatunkat
                        </Typography>
                    </motion.div>
                </Container>
            </motion.div>

            <Container>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                >
                    <Paper elevation={3} sx={{ p: 4, mt: -8, mb: 6, borderRadius: 2 }}>
                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                1. Adatkezelő adatai
                            </Typography>
                            <Typography paragraph>
                                Cégnév: Toronyszerver KFT.<br />
                                Székhely: 2230 Gyömrő, Állomás utca 15.<br />
                                Cégjegyzékszám: [Cégjegyzékszám]<br />
                                Adószám: [Adószám]<br />
                                Email: iroda@toronyszerver.hu<br />
                                Telefon: +36 70 618 5311
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                2. A kezelt személyes adatok köre
                            </Typography>
                            <Typography paragraph>
                                Kapcsolatfelvétel során bekért adatok:
                            </Typography>
                            <ul>
                                <li>Név</li>
                                <li>Email cím</li>
                                <li>Telefonszám (opcionális)</li>
                                <li>Cég neve (opcionális)</li>
                                <li>Beosztás (opcionális)</li>
                                <li>Projekt részletek</li>
                            </ul>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                3. Az adatkezelés célja
                            </Typography>
                            <Typography paragraph>
                                Az adatkezelés célja a kapcsolatfelvétel, ajánlatadás, valamint a szerződéses kötelezettségek teljesítése.
                                Hírlevél feliratkozás esetén marketing célú megkeresések küldése.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                4. Az adatkezelés jogalapja
                            </Typography>
                            <Typography paragraph>
                                Az adatkezelés jogalapja az Ön önkéntes hozzájárulása, amelyet a kapcsolatfelvételi űrlap kitöltésével ad meg.
                                A hozzájárulást bármikor visszavonhatja az iroda@toronyszerver.hu címre küldött emailben.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                5. Az adatkezelés időtartama
                            </Typography>
                            <Typography paragraph>
                                A személyes adatokat a hozzájárulás visszavonásáig, de legfeljebb az utolsó kapcsolatfelvételtől számított 5 évig tároljuk.
                                A számviteli bizonylatokat a számvitelről szóló 2000. évi C. törvény 169. § alapján 8 évig őrizzük meg.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                6. Adatfeldolgozók
                            </Typography>
                            <Typography paragraph>
                                Tárhelyszolgáltató: [Szolgáltató neve]<br />
                                Email szolgáltató: [Szolgáltató neve]<br />
                                Az adatfeldolgozók az adatkezelővel kötött szerződés alapján végzik az adatok feldolgozását.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                7. Az érintettek jogai
                            </Typography>
                            <Typography paragraph>
                                Önt a következő jogok illetik meg:
                            </Typography>
                            <ul>
                                <li>Tájékoztatáshoz való jog</li>
                                <li>Hozzáféréshez való jog</li>
                                <li>Helyesbítéshez való jog</li>
                                <li>Törléshez való jog</li>
                                <li>Adatkezelés korlátozásához való jog</li>
                                <li>Adathordozhatósághoz való jog</li>
                                <li>Tiltakozáshoz való jog</li>
                            </ul>
                        </Box>

                        <Box>
                            <Typography variant="h5" gutterBottom color="primary">
                                8. Jogorvoslati lehetőségek
                            </Typography>
                            <Typography paragraph>
                                Amennyiben úgy érzi, hogy adatainak kezelése kapcsán sérelem érte, kérjük, először velünk vegye fel a kapcsolatot:
                                iroda@toronyszerver.hu
                            </Typography>
                            <Typography paragraph>
                                Jogainak megsértése esetén a Nemzeti Adatvédelmi és Információszabadság Hatósághoz fordulhat:<br />
                                Cím: 1055 Budapest, Falk Miksa utca 9-11.<br />
                                Postacím: 1363 Budapest, Pf.: 9.<br />
                                Telefon: +36 1 391 1400<br />
                                Email: ugyfelszolgalat@naih.hu
                            </Typography>
                        </Box>
                    </Paper>
                </motion.div>
            </Container>
        </div>
    );
};

export default Privacy; 